import { Injectable, inject } from '@angular/core';
import { TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';
import { GenderType, GenderTypeLabel, GenderTypeValue } from '../../constants/gender-enum';
import { NULL_VIEW_SYMBOL } from '../../constants/system-constants.model';

@Injectable({
  providedIn: 'root'
})
export class EnumService {
  private translation = inject(TranslationService);

  getStringEnumDropdownOptions<T extends string>(
    enumType: { [key: string]: T | string },
    translate: boolean = false,
  ): Array<{ text: string, value: T | string }> {
    return Object.keys(enumType).map((key) => { return { text: translate ? this.translation.instant(key) : key, value: enumType[key] }; });
  }

  getEnumDropdownOptions<T extends number>(
    enumType: { [key: string]: T | string },
    labels: { [key in T]: string },
    guides: { [key in T]: string },
    translate: boolean = false,
    useEnumValue: boolean = true,
    valueAsString?: boolean
  ): Array<{ text: string, value: T | string }> {
    return Object.keys(enumType)
      .filter((key) => typeof enumType[key] === 'number')
      .map((key) => {
        const enumValue = enumType[key] as T;
        return { text: translate ? this.translation.instant(labels[enumValue]) : labels[enumValue], value: useEnumValue ? (valueAsString ? enumValue?.toString() : enumValue) : guides[enumValue] };
      });
  }

  getEnumByMappedValue<T extends number>(
    enumType: { [key: string]: T | string },
    maps: { [key in T]: string },
    searchKey: string
  ): T | undefined {
    const enumValue = Object.keys(maps).find(key => maps[key] === searchKey);
    return enumValue ? Number(enumValue) as T : undefined;
  }

  getLabelByMappedValue<T extends string | number>(
    enumType: { [key: string]: T | string },
    labels: { [key in T]: string },
    searchKey: number
  ): string | undefined {
    return searchKey !== undefined && labels[searchKey] ? this.translation.instant(labels[searchKey]) : undefined;
  }

  getLabelByMappedName<T extends string | number>(
    enumType: { [key: string]: T | string },
    labels: { [key in T]: string },
    searchKey: string
  ): string | undefined {
    return searchKey !== undefined && enumType[searchKey] != undefined && labels[enumType[searchKey] as T] ? this.translation.instant(labels[enumType[searchKey] as T]) : undefined;
  }

  getEnumKeyByValue<T>(enumObj: T, value: string): string | undefined {
    return Object.keys(enumObj).find(key => enumObj[key] === value);
  }

  getGenderLabel(gender: string | null): string {
    if (!gender)
      return NULL_VIEW_SYMBOL;
    return this.getLabelByMappedValue(GenderType, GenderTypeLabel, this.getEnumByMappedValue(GenderType, GenderTypeValue, gender));
  }

}